module.exports = __webpack_public_path__ + "media/images/lane/laptop-77072241f20031a7f63537dd28afd731.svg";